import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
})
export class SearchComponent implements OnInit {
  @Input() placeholder: string | undefined;
  @Input() actionButton: boolean = false;
  @Input() statusDisabled: boolean = false;
  @Output() search = new EventEmitter();

  searchText = '';

  constructor() {}

  ngOnInit(): void {
    if (!this.placeholder) {
      this.placeholder = 'Pesquise aqui ...';
    }
  }

  filter(): void {
    if (this.actionButton) {
      return;
    }
    if (this.searchText && this.searchText.length > 2) {
      this.search.emit(this.searchText);
    } else {
      this.search.emit('');
    }
  }

  handleClick() {
    this.search.emit(this.searchText);
  }
}
